import './VehicleConditionReport.css';
import React, { useEffect, useState } from 'react';
import { validatevcr } from './VCRFormValidation';
import { showAlert, showConfirm } from '../../Services/CommonFunctions';
import AssignmentDetailsHeader from '../common/AssignmentDetailsHeader';
import { VCRService } from '../../Services/VCRService';
import { AssignmentService } from '../../Services/AssignmentService';
import { getUserInfoFromSession } from '../../Services/session.mgmt';
import Header from '../../Components/Header/Header';
import _ from 'lodash';
import { CommonDataService } from '../../Services/CommonDataService';
import PropTypes from 'prop-types';

function VehicleConditionReport(props) {
  const userInfo = getUserInfoFromSession();
  const teamWrkBpiNb = Number(props.bpiNo);
  console.log(teamWrkBpiNb);
  const [assignmentDetails, setAssignmentDetails] = useState([]);
  const [buyerCoBuyerInfo, setBuyerCoBuyerInfo] = useState([]);
  const [TireConditionOptions, setTireConditionOptions] = useState([]);
  const [OverallConditionOptions, setOverallConditionOptions] = useState([]);
  const [GeneralConditionOptions, setGeneralConditionOptions] = useState([]);
  const [InteriorConditionOptions, setInteriorConditionOptions] = useState([]);
  const [GlassConditionOptions, setGlassConditionOptions] = useState({});
  const [MechanicalConditionOptions, setMechanicalConditionOptions] = useState([]);
  const [AuctionLocationList, setAuctionLocationList] = useState([]);
  const [vcrFormData, setVcrFormData] = useState({});
  const [VehLocData, setVehLocData] = useState({});
  const [StateOrProvince, setStateOrProvince] = useState([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);
  const [, setRepoAssignmentStatus] = useState([]);
  const [accountInformation, setAccountInformation] = useState({});

  const stateProvinceLabel = userInfo.countryCd === 'CAN' ? 'PROVINCE: ' : 'STATE: ';
  const zipPostalLabel = userInfo.countryCd === 'CAN' ? 'POSTAL CODE:' : 'ZIP CODE:';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          tireConditionResponse,
          overallConditionResponse,
          generalConditionResponse,
          interiorConditionResponse,
          glassConditionResponse,
          mechanicalConditionResponse,
          stateOrProviceResponse,
          auctionLocationListResponse,
          vcr,
          vehloc,
          groundingInfo,
          assigmentInfoResp,
          VcrFormResponse,
          VehlocFormResponse,
          repoAssignmentStatus,
          accountInfoResponse,
        ] = await Promise.all([
          VCRService.getTireCondition(),
          VCRService.getOverallCondition(),
          VCRService.getGeneralCondition(),
          VCRService.getInteriorCondition(),
          VCRService.getGlassCondition(),
          VCRService.getMechanicalCondition(),
          VCRService.getStateOrProvinceByStAbbr(userInfo.countryCd),
          VCRService.getAuctionLocationList(userInfo.countryCd),
          AssignmentService.getVcrDetails(teamWrkBpiNb),
          AssignmentService.getVehLocDetails(teamWrkBpiNb),
          AssignmentService.getGroundingInfo(teamWrkBpiNb),
          AssignmentService.getAssignmentInfo(teamWrkBpiNb, userInfo.cntrctrNb),
          VCRService.getVcrObj(),
          VCRService.getVehLocObj(),
          AssignmentService.getRepoAssignmentStatusInfo(teamWrkBpiNb, userInfo.cntrctrNb),
          CommonDataService.getAccountInfo(teamWrkBpiNb, userInfo.cntrctrNb),
        ]);

        setTireConditionOptions(tireConditionResponse.data);
        setOverallConditionOptions(overallConditionResponse.data);
        setGeneralConditionOptions(generalConditionResponse.data);
        setInteriorConditionOptions(interiorConditionResponse.data);
        setGlassConditionOptions(glassConditionResponse.data);
        setMechanicalConditionOptions(mechanicalConditionResponse.data);
        setStateOrProvince(stateOrProviceResponse);
        setAuctionLocationList(auctionLocationListResponse.data);
        setRepoAssignmentStatus(repoAssignmentStatus.data?.result?.repoAssignmentStatus);
        setAccountInformation(accountInfoResponse.data);
        setVcrFormData({
          ...VcrFormResponse.data,
          teamWrkBpiNb: teamWrkBpiNb,
          lstUpdtUserId: userInfo.userid,
        });
        setVehLocData({
          ...VehlocFormResponse.data,
          teamWrkBpiNb: teamWrkBpiNb,
          lstUpdtUserId: userInfo.userid,
          auctCd: vehloc?.data?.auctLocCd ?? '',
        });

        if (vcr !== null && vehloc !== null) {
          setVcrFormData(() => ({
            teamWrkBpiNb: teamWrkBpiNb,
            rcvrDt: vcr?.data?.vcr?.rcvrDt ?? '',
            prepByTx: vcr?.data?.vcr?.prepByTx ?? '',
            prepDt: vcr?.data?.vcr?.prepDt ?? '',
            vehMlgeNb: vcr?.data?.vcr?.vehMlgeNb ?? '',
            keysInd: vcr?.data?.vcr?.keysInd ?? '',
            accAcIn: vcr?.data?.vcr?.accAcIn ?? 'N',
            accPwrSeatIn: vcr?.data?.vcr?.accPwrSeatIn ?? 'N',
            accFmRadIn: vcr?.data?.vcr?.accFmRadIn ?? 'N',
            accTiltIn: vcr?.data?.vcr?.accTiltIn ?? 'N',
            accAtrnsIn: vcr?.data?.vcr?.accAtrnsIn ?? 'N',
            accVnlRfIn: vcr?.data?.vcr?.accVnlRfIn ?? 'N',
            accPwrWinIn: vcr?.data?.vcr?.accPwrWinIn ?? 'N',
            accAftcRdoIn: vcr?.data?.vcr?.accAftcRdoIn ?? 'N',
            accCrsCtlIn: vcr?.data?.vcr?.accCrsCtlIn ?? 'N',
            accDieselIn: vcr?.data?.vcr?.accDieselIn ?? 'N',
            genCndtnCd: vcr?.data?.vcr?.genCndtnCd ?? '',
            mechCndtnCd: vcr?.data?.vcr?.mechCndtnCd ?? '',
            glsCndtnCd: vcr?.data?.vcr?.glsCndtnCd ?? '',
            glsBrknDs: vcr?.data?.vcr?.glsBrknDs ?? '',
            lfTireCndtnCd: vcr?.data?.vcr?.lfTireCndtnCd ?? '',
            rfTireCndtnCd: vcr?.data?.vcr?.rfTireCndtnCd ?? '',
            lrTireCndtnCd: vcr?.data?.vcr?.lrTireCndtnCd ?? '',
            rrTireCndtnCd: vcr?.data?.vcr?.rrTireCndtnCd ?? '',
            spTireCndtnCd: vcr?.data?.vcr?.spTireCndtnCd ?? '',
            intCndtnCd: vcr?.data?.vcr?.intCndtnCd ?? '',
            intExplDs: vcr?.data?.vcr?.intExplDs ?? '',
            ovrlBodyCndtnCd: vcr?.data?.vcr?.ovrlBodyCndtnCd ?? '',
            ovrlPntCndtnCd: vcr?.data?.vcr?.ovrlPntCndtnCd ?? '',
            ovrlBmprCndtnCd: vcr?.data?.vcr?.ovrlBmprCndtnCd ?? '',
            cndtnBumpfIn: vcr?.data?.vcr?.cndtnBumpfIn ?? 'N',
            cndtnBumprIn: vcr?.data?.vcr?.cndtnBumprIn ?? 'N',
            cndtnDsfDrIn: vcr?.data?.vcr?.cndtnDsfDrIn ?? 'N',
            cndtnDsfQpIn: vcr?.data?.vcr?.cndtnDsfQpIn ?? 'N',
            cndtnDsrDrIn: vcr?.data?.vcr?.cndtnDsrDrIn ?? 'N',
            cndtnDsrQpIn: vcr?.data?.vcr?.cndtnDsrQpIn ?? 'N',
            cndtnHoodIn: vcr?.data?.vcr?.cndtnHoodIn ?? 'N',
            cndtnPsfDrIn: vcr?.data?.vcr?.cndtnPsfDrIn ?? 'N',
            cndtnPsfQpIn: vcr?.data?.vcr?.cndtnPsfQpIn ?? 'N',
            cndtnPsrDrIn: vcr?.data?.vcr?.cndtnPsrDrIn ?? 'N',
            cndtnPsrQpIn: vcr?.data?.vcr?.cndtnPsrQpIn ?? 'N',
            cndtnRoofIn: vcr?.data?.vcr?.cndtnRoofIn ?? 'N',
            cndtnTrnkIn: vcr?.data?.vcr?.cndtnTrnkIn ?? 'N',
            vehRcvOthrSpcfy: vcr?.data?.vcr?.vehRcvOthrSpcfy ?? '',
            vehRcvrdFromNm: vcr?.data?.vcr?.vehRcvrdFromNm ?? '',
            vehRcvrdAddrTx: vcr?.data?.vcr?.vehRcvrdAddrTx ?? '',
            vehRcvrdCityNm: vcr?.data?.vcr?.vehRcvrdCityNm ?? '',
            vehRcvrdStAbbrCd: vcr?.data?.vcr?.vehRcvrdStAbbrCd ?? '',
            vehRcvrdZipCd: vcr?.data?.vcr?.vehRcvrdZipCd ?? '',
            cstRlsIn: vcr?.data?.vcr?.cstRlsIn ?? '',
            cstRlsDs: vcr?.data?.vcr?.cstRlsDs ?? '',
            athNtfyIn: vcr?.data?.vcr?.athNtfyIn ?? '',
            athNtfyNm: vcr?.data?.vcr?.athNtfyNm ?? '',
            athNtfyAddrTx: vcr?.data?.vcr?.athNtfyAddrTx ?? '',
            athNtfyCityNm: vcr?.data?.vcr?.athNtfyCityNm ?? '',
            athNtfyStAbbrCd: vcr?.data?.vcr?.athNtfyStAbbrCd ?? '',
            athNtfyZipCd: vcr?.data?.vcr?.athNtfyZipCd ?? '',
            othCmtDs: vcr?.data?.vcr?.othCmtDs ?? '',
            dmgEstAm: vcr?.data?.vcr?.dmgEstAm ?? '',
            msgEquipDs: vcr?.data?.vcr?.msgEquipDs ?? '',
            vehDmgTx: vcr?.data?.vcr?.vehDmgTx ?? '',
            lstUpdtUserId: userInfo.userid.trim(),
          }));
          setVehLocData(() => ({
            ...vehloc.data,
            vehlocTypCd: groundingInfo?.data?.vehLocTypCd ?? '',
            auctCd: groundingInfo?.data?.auctLocCd ?? '',
            auctDs: groundingInfo?.data?.auctLocNm ?? '',
            teamWrkBpiNb: teamWrkBpiNb,
            addrLine1Tx: vehloc?.data?.addrLine1Tx ?? '',
            addrLine2Tx: vehloc?.data?.addrLine2Tx ?? '',
            cityNm: vehloc?.data?.cityNm ?? '',
            stAbbrCd: vehloc?.data?.stAbbrCd ?? '',
            zipCd: vehloc?.data?.zipCd ?? '',
            phnCityAreaCd: vehloc?.data?.phnCityAreaCd ?? '',
            phnNb: vehloc?.data?.phnNb ?? '',
            lstUpdtUserId: userInfo.userid.trim(),
            vehLocNm: vehloc?.data?.vehLocNm ?? '',
          }));
        }
        setAssignmentDetails(assigmentInfoResp.data);
        console.log(
          `getBuyerCobuyer Params coBusCd: ${accountInfoResponse?.data?.coBusCd} ` +
          `disorigBranchCd: ${accountInfoResponse?.data?.discorigBranchCd} ` +
          `custAcctNb: ${accountInfoResponse?.data?.custAcctNb}`
        );
        AssignmentService.getBuyerCobuyerInfo(
          accountInfoResponse?.data?.coBusCd,
          accountInfoResponse?.data?.discorigBranchCd,
          accountInfoResponse?.data?.custAcctNb
        )
          .then((buyerInfoResp) => {
            console.log('getBuyerCobuyer response:', buyerInfoResp);
            setBuyerCoBuyerInfo(buyerInfoResp?.data);
            setLoading(false);
          })
          .catch((err) => {
            console.log(`Error Fetching Buyer Co-Buyer Info: `, err);
            setLoading(false);
          });
      } catch (err) {
        console.log(`Error on Fetching Vehicle Condition Report Information: ${err}`);

      }
    };

    fetchData();
  }, [teamWrkBpiNb, userInfo.cntrctrNb, userInfo.countryCd, userInfo.userid]);

  const clearFormData = async () => {
    try {
      const [VcrFormReponse, VehlocFormResponse] = await Promise.all([
        VCRService.getVcrObj(),
        VCRService.getVehLocObj(),
      ]);
      setVcrFormData(VcrFormReponse.data);
      setVehLocData(VehlocFormResponse.data);
    } catch (err) {
      setErr(`Error fetching form object: ${err}`);
    }
  };
  const reset = async () => {
    if (await showConfirm('All data will be cleared, proceed?')) {
      clearFormData();
    } else {
      return null;
    }
  };

  const convertValidVcrData = (VcrFromData) => {
    let validData = { ...VcrFromData };
    if (VcrFromData.vehRcvrdFromNm === 'OTHER') {
      validData = {
        ...validData,
        vehRcvrdFromNm: VcrFromData.vehRcvOthrSpcfy,
      };
    }
    delete validData.vehRcvOthrSpcfy;
    if (VcrFromData.keysInd === '') {
      validData = {
        ...validData,
        keysInd: ' ',
      };
    }
    if (VcrFromData.athNtfyIn === '') {
      validData = {
        ...validData,
        athNtfyIn: ' ',
      };
    }
    return validData;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(VehLocData);
    let errormsg = validatevcr(vcrFormData, VehLocData, userInfo.countryCd);
    try {
      if (errormsg !== null) {
        await showAlert(errormsg, 'warning');
      } else {
        let validVcrData = convertValidVcrData(vcrFormData);
        await saveVcr(validVcrData);
        await saveAuctionLoc(VehLocData);
        if (VehLocData.vehLoc !== 'A') {
          let dbvehlocData = {
            teamWrkBpiNb: teamWrkBpiNb,
            vehLocNm: VehLocData.vehLocNm,
            addrLine1Tx: VehLocData.addrLine1Tx,
            addrLine2Tx: VehLocData.addrLine2Tx,
            cityNm: VehLocData.cityNm,
            stAbbrCd: VehLocData.stAbbrCd,
            zipCd: VehLocData.zipCd,
            phnCityAreaCd: VehLocData.phnCityAreaCd,
            phnNb: VehLocData.phnNb,
            lstUpdtUserId: userInfo.userid,
          };
          if (saveVehLoc(dbvehlocData)) {
            showAlert('VCR & Vehloc Information Saved Successfully!!', 'success');
            props.onContinue();
          } else {
            console.error('Failed to save vehicle location.');
          }
        } else {
          showAlert('VCR & Vehloc Information Saved Successfully!!', 'success');
          props.onContinue();
        }
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  //insert into ZBPT102_VCR table
  async function saveVcr(vcrData) {
    try {
      console.log(vcrData);
      const response = VCRService.saveVcr(vcrData);
      let wf2Obj = {
        teamWrkBpiNb: teamWrkBpiNb,
        wfCmtCd: 'G',
        wfCmtTx: 'VCR | Mileage | ' + vcrData.vehMlgeNb,
        wfUserIdCd: userInfo.userid,
        lstUpdtUserId: userInfo.userid,
      };
      const response2 = await VCRService.InsWorkflowCommentForWF2(wf2Obj);
      console.log(response2.data);
      let vcrOtherComment = vcrData.othCmtDs.trim();
      if (vcrOtherComment.length !== 0) {
        let com1 = 'VCR | Other Comments | ' + vcrOtherComment;
        wf2Obj = {
          teamWrkBpiNb: teamWrkBpiNb,
          wfCmtCd: 'G',
          wfCmtTx: com1,
          wfUserIdCd: userInfo.userid,
          lstUpdtUserId: userInfo.userid,
        };
        const response3 = await VCRService.InsWorkflowCommentForWF2(wf2Obj);
        console.log(response3.data);
      }
      console.log('VCR Information Saved Successfully!!' + response);
    } catch (err) {
      console.error(err);
      showAlert(err.message, 'error');
    }
  }

  function saveVehLoc(VehLocData) {
    try {
      console.log(VehLocData);
      VCRService.saveVehLoc(VehLocData);
      console.log('Vehloc Information Saved Successfully!!');
      return true;
    } catch (err) {
      console.error(err);
      showAlert(err.message, 'error');
    }
  }

  async function saveAuctionLoc(VehLocData) {
    try {
      if (VehLocData.vehlocTypCd === 'A') {
        let auctionData = {
          auctLocCd: VehLocData.auctCd,
          auctLocNm: VehLocData.auctDs,
          propRcvrIn: 'N',
          userId: userInfo.userid,
          bpiNb: teamWrkBpiNb,
        };
        VCRService.updateAuctionGrounding(auctionData);
        console.log('Vehloc Information Saved Successfully!!');
      } else {
        let nonAuctionData = {
          vehlocTypCd: VehLocData.vehlocTypCd,
          propRcvrIn: 'N',
          userId: userInfo.userid,
          bpiNb: teamWrkBpiNb,
        };
        const response = VCRService.updateNonAuctionGrounding(nonAuctionData);
        console.log('Vehloc Information Saved Successfully!!', response);
      }
    } catch (err) {
      console.error(err);
      showAlert(err.message, 'error');
    }
  }

  const onChangeHandler = (event) => {
    setVcrFormData(() => ({
      ...vcrFormData,
      [event.target.name]: event.target.value,
    }));
  };
  const onChangeHandlerCheckBox = (event) => {
    console.log(event.target.checked);
    const { name, checked } = event.target;

    setVcrFormData((prevData) => ({
      ...prevData,
      [name]: checked ? 'Y' : 'N', // Set to "Y" if checked, "N" if unchecked
    }));
  };
  const onChangeHandlerVehLoc = (event) => {
    setVehLocData(() => ({
      ...VehLocData,
      [event.target.name]: event.target.value,
    }));
  };
  const onChangeHandlerAucLoc = (e) => {
    const selectedOption = AuctionLocationList.find((option) => option.auctLocDs === e.target.value);

    setVehLocData((prevData) => ({
      ...prevData,
      auctCd: selectedOption ? selectedOption.auctLocCd : '',
      auctDs: selectedOption ? selectedOption.auctLocDs : '',
    }));
  };
  const onChangeHandlerInt = (event) => {
    setVcrFormData(() => ({
      ...vcrFormData,
      [event.target.name]: Number(event.target.value),
    }));
  };


  const displayCustomerName = (buyerCoBuyerInfo) => {
    if (!buyerCoBuyerInfo) return '';

    const { firstNm1 = '', firstNm2 = '', lastNm1 = '', coBusNm = '' } = buyerCoBuyerInfo;

    let displayValue = ' ';

    if (firstNm1) {
      displayValue += firstNm1.trim() + ' ';
    }
    if (firstNm2) {
      displayValue += firstNm2.trim() + ' ';
    }
    if (lastNm1) {
      displayValue += lastNm1.trim();
    }

    if (displayValue !== ' ') {
      return displayValue;
    }

    return coBusNm.trim();
  };

  const renderBuyerInfo = () => {
    if (_.isEmpty(buyerCoBuyerInfo)) {
      return <div>No buyer or co-buyer information available.</div>;
    } else if (buyerCoBuyerInfo?.coBuyers?.length > 0) {
      return (
        <div className="fds-layout-grid__inner p-0">
          <div className="fds-layout-grid__cell--span-4">CUSTOMER NAME: {displayCustomerName(buyerCoBuyerInfo)}</div>
          <div className="fds-layout-grid__cell--span-4">
            COBUYER NAME: {displayCustomerName(buyerCoBuyerInfo.coBuyers[0])}
          </div>
          <div className="fds-layout-grid__cell--span-4">ACCOUNT NO: {accountInformation?.custAcctNb}</div>
        </div>
      );
    } else {
      return (
        <div className="fds-layout-grid__inner p-0">
          <div className="fds-layout-grid__cell--span-6">CUSTOMER NAME: {displayCustomerName(buyerCoBuyerInfo)}</div>
          <div className="fds-layout-grid__cell--span-6">ACCOUNT NO: {accountInformation?.custAcctNb}</div>
        </div>
      );
    }
  };

  if (loading) {
    return (
      <>
        <Header heading="" />
        <br />
        Loading...
      </>
    );
  }
  return (
    <div>
      {err ? (
        <div className="error-message" style={{ color: 'red' }}>
          {err}
        </div>
      ) : (
        <div className="data-content">
          <br />
          <AssignmentDetailsHeader bpiNo={teamWrkBpiNb} />
          <div style={{ textAlign: 'center', padding: 2 + 'em' }}>
            VEHICLE CONDITION REPORT
            <br />
            Vehicle Disposal Repossession Analysis
          </div>
          {/*-----form design started----*/}
          {/*---Customer details----*/}
          <form onSubmit={handleSubmit}>
            <fieldset disabled={props.status === 'H'}>
              <div className="f-0">
                <div className="fds-layout-grid p-0">{renderBuyerInfo()}</div>
                <hr />
                {/*------Date of recovery info----*/}
                <div style={{ textAlign: 'center' }}>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-4">
                        <label htmlFor="rcvrDt">DATE OF RECOVERY: </label>
                        <input
                          type="date"
                          placeholder="Lorem Ipsum"
                          className="s-1"
                          id="rcvrDt"
                          name="rcvrDt"
                          value={vcrFormData.rcvrDt}
                          onChange={onChangeHandler}
                        />
                      </div>
                      <div className=" row fds-layout-grid__cell--span-4">
                        <div className="column form-group">
                          <span className="label-like">Year</span> {assignmentDetails[0].vehMdlYr}
                        </div>
                        <div className="column form-group">
                          <span className="label-like">MAKE</span> {assignmentDetails[0].makeDescTx}
                        </div>
                        <div className="column form-group">
                          <span className="label-like">MODEL</span> {assignmentDetails[0].mdlDescTx}
                        </div>
                      </div>
                      <div className=" fds-layout-grid__cell--span-4">
                        <div className="form-group">
                          <span className="label-like">Vehicle Identification Number</span>
                          {assignmentDetails[0]?.vinSerialNb}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/*------PREPARED BY info-----*/}
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-6">
                        <label htmlFor="prepByTx">PREPARED BY:(NAME OF EMPLOYEE) </label>
                        <input
                          type="text"
                          placeholder=""
                          id="prepByTx"
                          name="prepByTx"
                          value={vcrFormData.prepByTx}
                          onChange={onChangeHandler}
                        />
                      </div>
                      <div className="fds-layout-grid__cell--span-6">
                        <label htmlFor="prepDt">DATE PREPARED: </label>
                        <input
                          type="date"
                          placeholder="Lorem Ipsum"
                          className="s-1"
                          id="prepDt"
                          name="prepDt"
                          value={vcrFormData.prepDt}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/*----General Condition-----*/}
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-3">
                        <label htmlFor="vehMlgeNb">MILEAGE: </label>
                        <input
                          type="number"
                          placeholder=""
                          id="vehMlgeNb"
                          name="vehMlgeNb"
                          value={vcrFormData.vehMlgeNb}
                          onChange={onChangeHandlerInt}
                        />
                      </div>
                      <div className="fds-layout-grid__cell--span-2">
                        <span className="label-like">IGNITION KEY NO: {assignmentDetails[0]?.keyIgntnNb}</span>
                      </div>
                      <div className="fds-layout-grid__cell--span-2">
                        <span className="label-like">COLOR: {assignmentDetails[0]?.vehColorTx}</span>
                      </div>
                      <div className="fds-layout-grid__cell--span-5">
                        <div className="form-group">
                          <span className="label-like">GENERAL CONDITION: </span>
                          <fieldset className="fmc-check fmc-check--horizontal">
                            {GeneralConditionOptions.map((options) => (
                              <label key={options.key} htmlFor={`genCndtnCd-${options.key}`}>
                                <input
                                  type="radio"
                                  name="genCndtnCd"
                                  value={options.key}
                                  id={`genCndtnCd-${options.key}`} // Ensuring the input has a unique ID
                                  onChange={onChangeHandlerInt}
                                  checked={vcrFormData.genCndtnCd === options.key}
                                />
                                <span className="r-0">{options.value}</span>
                              </label>
                            ))}
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*----Keys-----*/}
                  <div>
                    <div className="fds-layout-grid p-0">
                      <div className="fds-layout-grid__cell--span-12">
                        {/* Flex container to align the key and radio buttons horizontally */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ marginRight: '20px' }}>KEYS:</div>
                          <fieldset
                            className="fmc-check fmc-check--horizontal"
                            style={{ display: 'flex', gap: '20px' }}
                          >
                            <label>
                              <input
                                type="radio"
                                name="keysInd"
                                value="Y"
                                checked={vcrFormData.keysInd === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span>YES</span>
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="keysInd"
                                value="N"
                                checked={vcrFormData.keysInd === 'N'}
                                onChange={onChangeHandler}
                              />
                              <span>NO</span>
                            </label>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/*--------Accessories------*/}
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-2">
                        <legend>ACCESSORIES:</legend>
                      </div>
                      <div className="fds-layout-grid__cell--span-10">
                        <div className="fds-layout-grid__inner p-0 ">
                          <div className="fds-layout-grid__cell--span-3 fmc-check">
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accAtrnsIn"
                                value="Y"
                                checked={vcrFormData.accAtrnsIn === 'Y'}
                                onChange={onChangeHandlerCheckBox}
                              />
                              <span className="r-1">Auto Trans</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accAcIn"
                                value="Y"
                                checked={vcrFormData.accAcIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">A/C</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accVnlRfIn"
                                value="Y"
                                checked={vcrFormData.accVnlRfIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">Vinyl Roof</span>
                            </label>
                          </div>
                          <div className="fds-layout-grid__cell--span-3 fmc-check">
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accPwrSeatIn"
                                value="Y"
                                checked={vcrFormData.accPwrSeatIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">P. Seats</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accPwrWinIn"
                                value="Y"
                                checked={vcrFormData.accPwrWinIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">P. Window</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accFmRadIn"
                                value="Y"
                                checked={vcrFormData.accFmRadIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1"> Radio</span>
                            </label>
                          </div>
                          <div className="fds-layout-grid__cell--span-3 fmc-check">
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accAftcRdoIn"
                                value="Y"
                                checked={vcrFormData.accAftcRdoIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">CD</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accTiltIn"
                                value="Y"
                                checked={vcrFormData.accTiltIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">Tilt Wheel</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accCrsCtlIn"
                                value="Y"
                                checked={vcrFormData.accCrsCtlIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">Speed Control</span>
                            </label>
                          </div>
                          <div className="fds-layout-grid__cell--span-3 fmc-check">
                            <label className="l-0">
                              <input
                                type="checkbox"
                                name="accDieselIn"
                                value="Y"
                                checked={vcrFormData.accDieselIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">Diesel</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                Mechanical Glass Tire and interior info
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-2">
                        <div className="form-group">
                          <span className="label-like">MECHANICAL:</span>
                          <fieldset className="fmc-check" style={{ marginTop: 1 + 'px' }}>
                            {MechanicalConditionOptions.map((options) => (
                              <label className="l-0" key={options.key}>
                                <input
                                  type="radio"
                                  name="mechCndtnCd"
                                  value={options.key}
                                  onChange={onChangeHandlerInt}
                                  checked={vcrFormData.mechCndtnCd === options.key}
                                />
                                <span className="r-1">{options.value}</span>
                              </label>
                            ))}
                          </fieldset>
                        </div>
                      </div>
                      <div className="fds-layout-grid__cell--span-2">
                        <div className="form-group">
                          <span className="label-like">GLASS:</span>
                          <fieldset className="fmc-check" style={{ marginTop: 1 + 'px' }}>
                            {GlassConditionOptions.map((opt) => (
                              <label className="l-0" key={opt.key}>
                                <input
                                  type="radio"
                                  name="glsCndtnCd"
                                  value={opt.key}
                                  onChange={onChangeHandlerInt}
                                  checked={vcrFormData.glsCndtnCd === parseInt(opt.key)}
                                />
                                <span className="r-1">{opt.value}</span>
                              </label>
                            ))}
                            <div className="form-group">
                              <label htmlFor="glsBrknDs">INDICATE LOCATION:</label>
                              <input
                                type="text"
                                placeholder=""
                                name="glsBrknDs"
                                id="glsBrknDs"
                                value={vcrFormData.glsBrknDs}
                                onChange={onChangeHandler}
                              />
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <div className="fds-layout-grid__cell--span-4" style={{ textAlign: 'center' }}>
                        <div className="form-group">
                          <span className="label-like" style={{ marginLeft: -15 + 'em' }}>
                            TIRES:
                          </span>
                          <div>
                            <label htmlFor="vehicle-select" style={{ paddingRight: 0.7 + 'em' }}>
                              Left Front
                            </label>
                            <select
                              name="lfTireCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.lfTireCndtnCd}
                            >
                              <option value=""></option>
                              {TireConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label htmlFor="vehicle-select" style={{ paddingRight: 1.15 + 'em' }}>
                              Left Rear
                            </label>
                            <select
                              name="lrTireCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.lrTireCndtnCd}
                            >
                              <option value=""></option>
                              {TireConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label htmlFor="vehicle-select">Right Front</label>
                            <select
                              name="rfTireCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.rfTireCndtnCd}
                            >
                              <option value=""></option>
                              {TireConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label htmlFor="vehicle-select" style={{ paddingRight: 0.4 + 'em' }}>
                              Right Rear
                            </label>
                            <select
                              name="rrTireCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.rrTireCndtnCd}
                            >
                              <option value=""></option>
                              {TireConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label htmlFor="vehicle-select" style={{ paddingRight: 3 + 'em' }}>
                              Spare
                            </label>
                            <select
                              name="spTireCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.spTireCndtnCd}
                            >
                              <option value=""></option>
                              {TireConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="fds-layout-grid__cell--span-4">
                        <div className="form-group">
                          <span className="label-like">INTERIOR:</span>
                          <fieldset className="fmc-check" style={{ marginTop: 1 + 'px' }}>
                            <option value=""></option>
                            {InteriorConditionOptions.map((options) => (
                              <label className="l-0" key={options.key}>
                                <input
                                  type="radio"
                                  name="intCndtnCd"
                                  value={options.key}
                                  onChange={onChangeHandlerInt}
                                  checked={vcrFormData.intCndtnCd === options.key}
                                />
                                <span className="r-1">{options.value}</span>
                              </label>
                            ))}
                            <div>
                              <span className="label-like">EXPLANATION:</span>
                              <input
                                type="text"
                                placeholder=""
                                name="intExplDs"
                                value={vcrFormData.intExplDs}
                                onChange={onChangeHandler}
                              />
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/*---Body condition details---*/}
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-4">
                        <div className="form-group">
                          <span className="label-like">BODY:</span>
                          <div>
                            <label htmlFor="vehicle-select" style={{ paddingRight: 2.6 + 'em' }}>
                              Body
                            </label>
                            <select
                              name="ovrlBodyCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.ovrlBodyCndtnCd}
                            >
                              <option value=""></option>
                              {OverallConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label htmlFor="vehicle-select" style={{ paddingRight: 2.5 + 'em' }}>
                              Paint
                            </label>
                            <select
                              name="ovrlPntCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.ovrlPntCndtnCd}
                            >
                              <option value=""></option>
                              {OverallConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label htmlFor="vehicle-select" style={{ paddingRight: 0.5 + 'em' }}>
                              Bumpers
                            </label>
                            <select
                              name="ovrlBmprCndtnCd"
                              id="vehicle-select"
                              className="s-1"
                              onChange={onChangeHandlerInt}
                              value={vcrFormData.ovrlBmprCndtnCd}
                            >
                              <option value=""></option>
                              {OverallConditionOptions.map((options) => (
                                <option key={options.key} value={options.key}>
                                  {options.value}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="fds-layout-grid__cell--span-8">
                        <div className="form-group">
                          <span className="label-like">Dent/Rust Location:</span>
                          <div className="fds-layout-grid__inner p-0 ">
                            <div className="fds-layout-grid__cell--span-4 fmc-check">
                              <span className="label-like">Driver Side:</span>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnDsfQpIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnDsfQpIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Front Quarter Panel</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnDsfDrIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnDsfDrIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Front Door</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnDsrDrIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnDsrDrIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Rear Door</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnDsrQpIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnDsrQpIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Rear Quarter Panel</span>
                              </label>
                            </div>
                            <div className="fds-layout-grid__cell--span-4 fmc-check">
                              <span className="label-like">Passenger Side:</span>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnPsfQpIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnPsfQpIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Front Quarter Panel</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnPsfDrIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnPsfDrIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Front Door</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnPsrDrIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnPsrDrIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Rear Door</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnPsrQpIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnPsrQpIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Rear Quarter Panel</span>
                              </label>
                            </div>
                            <div className="fds-layout-grid__cell--span-2 fmc-check">
                              <span className="label-like">Top:</span>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnHoodIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnHoodIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Hood</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnRoofIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnRoofIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Roof</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnTrnkIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnTrnkIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Trunk</span>
                              </label>
                            </div>
                            <div className="fds-layout-grid__cell--span-1 fmc-check">
                              <span className="label-like">Bumper:</span>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnBumpfIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnBumpfIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Front</span>
                              </label>
                              <label className="l-0">
                                <input
                                  type="checkbox"
                                  name="cndtnBumprIn"
                                  value="Y"
                                  checked={vcrFormData.cndtnBumprIn === 'Y'}
                                  onChange={onChangeHandlerCheckBox}
                                />
                                <span className="r-1">Rear</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/*---Remarks-- */}
                <div className="p-0">
                  <div className="fds-layout-grid p-0">
                    <div className="form-group">
                      <label htmlFor="msgEquipDs">REMARKS/MISSING EQUIPMENT :</label>
                      <input
                        type="text"
                        placeholder=""
                        className="i-1"
                        name="msgEquipDs"
                        id="msgEquipDs"
                        value={vcrFormData.msgEquipDs}
                        onChange={onChangeHandler}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="p-0">
                  <div className="fds-layout-grid p-0">
                    <div>
                      <label htmlFor="dmgEstAm">ESTIMATED INSURANCE DAMAGE AMOUNT :</label>
                      <input
                        type="text"
                        placeholder=""
                        style={{ width: 10 + 'em' }}
                        name="dmgEstAm"
                        id="dmgEstAm"
                        value={vcrFormData.dmgEstAm}
                        onChange={onChangeHandlerInt}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                {/*VEHICLE RECOVERED FROM*/}
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-6">
                        <div className="form-group">
                          <span className="label-like">Vehicle Recovered From</span>
                          <div className="fmc-check--horizontal">
                            <label className="l-0">
                              <input
                                type="radio"
                                name="vehRcvrdFromNm"
                                value="CUSTOMER"
                                onChange={onChangeHandler}
                                checked={vcrFormData.vehRcvrdFromNm === 'CUSTOMER'}
                              />
                              <span className="r-1">CUSTOMER</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="radio"
                                name="vehRcvrdFromNm"
                                value="OTHER"
                                onChange={onChangeHandler}
                                checked={vcrFormData.vehRcvrdFromNm === 'OTHER'}
                              />
                              <span className="r-1">OTHER (SPECIFY)</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="text"
                                id="vehRcvOthrSpcfy"
                                style={{ width: 10 + 'em' }}
                                name="vehRcvOthrSpcfy"
                                value={vcrFormData.vehRcvOthrSpcfy === 'CUSTOMER' ? '' : vcrFormData.vehRcvOthrSpcfy}
                                disabled={
                                  vcrFormData.vehRcvrdFromNm === 'CUSTOMER' && vcrFormData.vehRcvrdFromNm !== ''
                                }
                                onChange={onChangeHandler}
                              />
                              <span style={{ display: 'none' }}>Hidden text</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="fds-layout-grid__cell--span-6">
                        <div className="form-group">
                          <span className="label-like">Recovered From</span>
                          <div>
                            <label htmlFor="vehRcvrdAddrTx" className="width100">
                              ADDRESS:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="vehRcvrdAddrTx"
                              id="vehRcvrdAddrTx"
                              value={vcrFormData.vehRcvrdAddrTx}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <div>
                            <label htmlFor="vehRcvrdCityNm" className="width100">
                              CITY:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="vehRcvrdCityNm"
                              id="vehRcvrdCityNm"
                              value={vcrFormData.vehRcvrdCityNm}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <div>
                            <label className="l-0">
                              <span className="r-1 width100">{stateProvinceLabel}</span>
                              <select
                                name="vehRcvrdStAbbrCd"
                                className="s-2"
                                onChange={onChangeHandler}
                                value={vcrFormData.vehRcvrdStAbbrCd}
                              >
                                <option value=""></option>
                                {StateOrProvince?.map((options) => (
                                  <option key={options.stAbbrCd} value={options.stAbbrCd}>
                                    {options.stAbbrCd}
                                  </option>
                                ))}
                              </select>
                            </label>
                            <label className="l-0">
                              <span className="r-1">{zipPostalLabel} </span>
                              <input
                                type="text"
                                className="s-3"
                                name="vehRcvrdZipCd"
                                value={vcrFormData.vehRcvrdZipCd}
                                onChange={onChangeHandler}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/*Customer sign details*/}
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-8">
                        <div className="fmc-check">
                          <span className="label-like">WAS RELEASED SIGNED BY CUSTOMER? </span>
                          <label className="l-0">
                            <input
                              type="radio"
                              name="cstRlsIn"
                              value="Y"
                              onChange={onChangeHandler}
                              checked={vcrFormData.cstRlsIn === 'Y'}
                            />
                            <span className="r-1">YES</span>
                          </label>
                          <label className="l-0">
                            <input
                              type="radio"
                              name="cstRlsIn"
                              value="N"
                              onChange={onChangeHandler}
                              checked={vcrFormData.cstRlsIn === 'N'}
                            />
                            <span className="r-1">NO. IF NO, EXPLAIN </span>
                            <input
                              type="text"
                              className="s-0"
                              name="cstRlsDs"
                              value={vcrFormData.cstRlsDs}
                              disabled={vcrFormData.cstRlsIn === 'Y'}
                              onChange={onChangeHandler}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-4">
                        <div className="form-group">
                          <span className="label-like">IF NO, WERE PROPER AUTHORITIES NOTIFIED?</span>
                          <div className="fmc-check--horizontal">
                            <label className="l-0">
                              <input
                                type="radio"
                                name="athNtfyIn"
                                value="N"
                                onChange={onChangeHandler}
                                checked={vcrFormData.athNtfyIn === 'N'}
                              />
                              <span className="r-1">NO. IF NO, EXPLAIN BELOW</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="radio"
                                name="athNtfyIn"
                                value="Y"
                                checked={vcrFormData.athNtfyIn === 'Y'}
                                onChange={onChangeHandler}
                              />
                              <span className="r-1">YES</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="fds-layout-grid__cell--span-6">
                        <div className="form-group">
                          <span className="label-like">AUTHORITIES NOTIFIED:</span>
                          <div>
                            <label htmlFor="athNtfyNm" className="width100">
                              NAME:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="athNtfyNm"
                              id="athNtfyNm"
                              value={vcrFormData.athNtfyNm}
                              disabled={vcrFormData.athNtfyIn === 'N'}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <div>
                            <label htmlFor="athNtfyAddrTx" className="width100">
                              ADDRESS:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="athNtfyAddrTx"
                              id="athNtfyAddrTx"
                              value={vcrFormData.athNtfyAddrTx}
                              disabled={vcrFormData.athNtfyIn === 'N'}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <div>
                            <label htmlFor="athNtfyCityNm" className="width100">
                              CITY:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="athNtfyCityNm"
                              id="athNtfyCityNm"
                              value={vcrFormData.athNtfyCityNm}
                              disabled={vcrFormData.athNtfyIn === 'N'}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <div>
                            <label className="l-0">
                              <span className="r-1 width100">{stateProvinceLabel}</span>
                              <select
                                name="athNtfyStAbbrCd"
                                className="s-2"
                                onChange={onChangeHandler}
                                disabled={vcrFormData.athNtfyIn === 'N'}
                                value={vcrFormData.athNtfyStAbbrCd}
                              >
                                <option value=""></option>
                                {StateOrProvince?.map((options) => (
                                  <option key={options.stAbbrCd} value={options.stAbbrCd}>
                                    {options.stAbbrCd}
                                  </option>
                                ))}
                              </select>
                            </label>
                            <label className="l-0">
                              <span className="r-1">{zipPostalLabel}</span>
                              <input
                                type="text"
                                className="s-3"
                                name="athNtfyZipCd"
                                value={vcrFormData.athNtfyZipCd}
                                disabled={vcrFormData.athNtfyIn === 'N'}
                                onChange={onChangeHandler}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {/*OTHER COMMENTS*/}
                <div className="p-0">
                  <div className="fds-layout-grid p-0">
                    <div className="form-group">
                      <label htmlFor="othCmtDs">OTHER COMMENTS :</label>
                      <input
                        type="text"
                        placeholder=""
                        className="i-1"
                        name="othCmtDs"
                        id="othCmtDs"
                        style={{ height: 100 + 'px' }}
                        value={vcrFormData.othCmtDs}
                        onChange={onChangeHandler}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                {/*   vehicle located at */}
                <div>
                  <div className="fds-layout-grid p-0">
                    <div className="fds-layout-grid__inner p-0 ">
                      <div className="fds-layout-grid__cell--span-12">
                        <span className="label-like">VEHICLE LOCATED AT:</span>
                        <div className="fmc-check"></div>
                      </div>
                      <div className="fds-layout-grid__cell--span-6">
                        <div className="form-group">
                          <div className="fmc-check">
                            <label className="l-0">
                              <input
                                type="radio"
                                name="vehlocTypCd"
                                value="A"
                                checked={VehLocData.vehlocTypCd === 'A'}
                                onChange={onChangeHandlerVehLoc}
                              />
                              <span className="r-1">AUCTION</span>
                              <select
                                name="auctDs"
                                id="vehicle-select"
                                className="s-4"
                                onChange={onChangeHandlerAucLoc}
                                disabled={(VehLocData.vehlocTypCd !== 'A') & (VehLocData.vehlocTypCd !== '')}
                                value={VehLocData.auctDs}
                              >
                                <option value=""></option>
                                {AuctionLocationList.map((options) => (
                                  <option key={options.auctLocCd} value={options.auctLocDs}>
                                    {options.auctLocDs}
                                  </option>
                                ))}
                              </select>
                            </label>

                            <label className="l-0">
                              <input
                                type="radio"
                                name="vehlocTypCd"
                                value="C"
                                checked={VehLocData.vehlocTypCd === 'C'}
                                onChange={onChangeHandlerVehLoc}
                              />
                              <span className="r-1">CONTRACTOR</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="radio"
                                name="vehlocTypCd"
                                value="D"
                                checked={VehLocData.vehlocTypCd === 'D'}
                                onChange={onChangeHandlerVehLoc}
                              />
                              <span className="r-1">DEALER</span>
                            </label>
                            <label className="l-0">
                              <input
                                type="radio"
                                name="vehlocTypCd"
                                value="O"
                                checked={VehLocData.vehlocTypCd === 'O'}
                                onChange={onChangeHandlerVehLoc}
                              />
                              <span className="r-1">OTHER</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="fds-layout-grid__cell--span-6">
                        <div className="form-group">
                          <div>
                            <label htmlFor="vehLocNm" style={{ paddingRight: 6 + 'em' }}>
                              NAME:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="vehLocNm"
                              id="vehLocNm"
                              value={VehLocData.vehLocNm}
                              disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                              onChange={onChangeHandlerVehLoc}
                            />
                          </div>
                          <div>
                            <label htmlFor="addrLine1Tx" style={{ paddingRight: 0.5 + 'em' }}>
                              ADDRESS LINE1:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="addrLine1Tx"
                              id="addrLine1Tx"
                              value={VehLocData.addrLine1Tx}
                              disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                              onChange={onChangeHandlerVehLoc}
                            />
                          </div>
                          <div>
                            <label htmlFor="addrLine2Tx" style={{ paddingRight: 0.4 + 'em' }}>
                              ADDRESS LINE2:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="addrLine2Tx"
                              id="addrLine2Tx"
                              value={VehLocData.addrLine2Tx}
                              disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                              onChange={onChangeHandlerVehLoc}
                            />
                          </div>
                          <div>
                            <label htmlFor="cityNm" style={{ paddingRight: 7 + 'em' }}>
                              CITY:
                            </label>
                            <input
                              type="text"
                              className="s-1"
                              name="cityNm"
                              id="cityNm"
                              value={VehLocData.cityNm}
                              disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                              onChange={onChangeHandlerVehLoc}
                            />
                          </div>
                          <div>
                            <label className="l-0">
                              <span
                                className="r-1"
                                style={{
                                  display: 'inline-block',
                                  width: '131px',
                                }}
                              >
                                {stateProvinceLabel}
                              </span>
                              <select
                                name="stAbbrCd"
                                className="s-2"
                                value={VehLocData.stAbbrCd}
                                onChange={onChangeHandlerVehLoc}
                                disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                              >
                                <option value=""></option>
                                {StateOrProvince?.map((options) => (
                                  <option key={options.stAbbrCd} value={options.stAbbrCd}>
                                    {options.stAbbrCd}
                                  </option>
                                ))}
                              </select>
                            </label>
                            <label className="l-0">
                              <span className="r-1">{zipPostalLabel}</span>
                              <input
                                type="text"
                                className="s-3"
                                name="zipCd"
                                value={VehLocData.zipCd}
                                disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                                onChange={onChangeHandlerVehLoc}
                              />
                            </label>
                          </div>
                          <div>
                            <label className="l-0">
                              <span className="r-1" style={{ paddingRight: 5 + 'em' }}>
                                PHONE:
                              </span>
                              <input
                                type="text"
                                className="s-2"
                                name="phnCityAreaCd"
                                value={VehLocData.phnCityAreaCd}
                                disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                                onChange={onChangeHandlerVehLoc}
                              />
                            </label>
                            <label className="l-0">
                              <input
                                type="text"
                                className="s-1"
                                name="phnNb"
                                value={VehLocData.phnNb}
                                disabled={(VehLocData.vehlocTypCd === 'A') & (VehLocData.vehlocTypCd !== '')}
                                onChange={onChangeHandlerVehLoc}
                              />
                              <span style={{ display: 'none' }}>Hidden Text</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <div style={{ textAlign: 'center', paddingTop: 3 + 'em', fontSize: '0.75em' }}>
              <span className="dot"></span> Prior to recording the mileage reflected on the vehicle's odometer. Consider
              the age, appearance and condition of the vehicle and look for the indicators of mileage discrepancies such
              as oil change stickers, repair work receipts, warranty book entries and odometer replacement stickers.{' '}
              Note any mileage discrepancies or inconsistencies in the Comments section.
            </div>
            <div
              style={{
                textAlign: 'center',
                paddingTop: 1 + 'em',
                fontSize: '0.75em',
                margin: 2 + 'em',
              }}
            >
              <span className="dot"> </span> California Repossessions: In accordance with Section 7505. 115of Business
              and Professions code, this condition report is a general assessment of the collateral and does not
              including all damage or missing parts.
            </div>
            <section style={{ padding: 2 + 'em' }}>
              <div className="fds-align--center">
                <span>FCNA 16779</span>
                <button type="submit" className="fmc-button" style={{ marginLeft: 0.5 + 'em' }}>
                  Continue
                </button>
                <button type="button" className="fmc-button" style={{ marginLeft: 2 + 'em' }} onClick={reset}>
                  Reset
                </button>
              </div>
            </section>
          </form>
        </div>
      )}
    </div>
  );
}

VehicleConditionReport.propTypes = {
  bpiNo: PropTypes.any,
  onContinue: PropTypes.any,
  status: PropTypes.any,
};

export default VehicleConditionReport;
